<template>
    <v-container>
         <v-row>
            <v-col cols="14" offset="1" sm="16" offset-sm="0">
               <h2 class="section-subtitle">Členové týmu</h2>
               <v-row>
                  <v-col cols="16" offset="0" md="10" offset-md="3" sm="14" offset-sm="1">
                    <div class="team-members__box">
                        <v-row v-for="member in players" :key="member.nickname">
                            <div class="team-members__boxitem">
                            <v-col cols="16" sm="2">
                                <user-avatar-view :settings="member.avatar" />
                            </v-col>
                            <v-col cols="16" md="10" sm="8" class="aligncenter">
                                <p class="team-members__member">{{ member.nickname }}</p>
                            </v-col>
                            <v-col cols="10" offset="3" md="4" offset-md="0" sm="6" offset-sm="0" class="aligncenter">
                                <div class="team-members__flex">
                                    <v-btn dark large class="btn-without-border" icon :to="{ name: 'userDetail', params: { id: member.id } }" href="#">Detail</v-btn>
                                    <v-btn dark large v-if="canFireMember && user.id !== member.id" text icon class="btn-without-border" @click.stop="openRemovePlayerDialog(member)">
                                        Smazat
                                    </v-btn>
                                </div>
                            </v-col>
                        </div>
                        </v-row>
                    </div>
                    <fire-member
                        v-if="removePlayerDialogOpened"
                        :player="removeDialogPlayer"
                        @close="onRemovePlayerDialogClose"
                    />
                  </v-col>
               </v-row>
            </v-col>
         </v-row>
      </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import UserAvatarView from '../UserAvatar/UserAvatarView';
    import FireMember from './FireMember';

    export default {
        name: 'TeamMembers',
        components: {
            UserAvatarView,
            FireMember,
        },
        props: {
            players: {
                type: Array,
                required: true,
            },
            canFireMember: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data () {
            return {
                playersHeader: [
                    {
                        text: 'Hráč',
                        value: 'name',
                    },
                    {
                        text: 'Akce',
                        value: 'id',
                        sortable: false,
                        align: 'center',
                        width: this.columnActionsWidth(),
                    },
                ],
                sendCreditDialogOpened: false,
                sendCreditDialogRecipient: null,
                removePlayerDialogOpened: false,
                removeDialogPlayer: null,
            };
        },
        computed: {
            ...mapState ({
                //team: state => state.team.myTeam,
                user: state => state.user.user,
            }),
        },
        methods: {
            openSendCreditDialog (player) {
                this.sendCreditDialogRecipient = player;
                this.sendCreditDialogOpened = true;
            },
            onSendDialogCreditClose () {
                this.sendCreditDialogOpened = false;
                this.sendCreditDialogRecipient = null;
            },
            openRemovePlayerDialog (player) {
                this.removeDialogPlayer = player;
                this.removePlayerDialogOpened = true;
            },
            onRemovePlayerDialogClose () {
                this.removePlayerDialogOpened = false;
                this.removeDialogPlayer = null;
            },
            columnActionsWidth () {
                if (this.canSendCredit && this.canFireMember) {
                    return 140;
                } else if (this.canSendCredit || this.canFireMember) {
                    return 110;
                }
            },
        },
    }
</script>
